export default {
  PAYMENT_MANAGEMENT_LIST_REQUEST: 'APP/PAYMENT_MANAGEMENT/PAYMENT_MANAGEMENT_REQUEST',
  PAYMENT_MANAGEMENT_LIST_SUCCESS: 'APP/PAYMENT_MANAGEMENT/PAYMENT_MANAGEMENT_SUCCESS',
  PAYMENT_MANAGEMENT_LIST_ERROR: 'APP/PAYMENT_MANAGEMENT/PAYMENT_MANAGEMENT_ERROR',
};
